import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { notificationApi } from '../../api/notificationApi'
import { Notification } from '../../types'

interface NotificationState {
  notifications: Notification[]
  unreadCount: number
  loading: boolean
}

const initialState: NotificationState = {
  notifications: [],
  unreadCount: 0,
  loading: false,
}

export const fetchUnreadCount = createAsyncThunk('notifications/fetchUnreadCount', async () => {
  const response = await notificationApi.getUnreadCount()
  return response.data.data.count
})

export const fetchNotifications = createAsyncThunk('notifications/fetchAll', async () => {
  const response = await notificationApi.getNotifications(0, 20)
  return response.data.data.content
})

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    incrementUnread: (state) => { state.unreadCount += 1 },
    clearUnread: (state) => { state.unreadCount = 0 },
    addNotification: (state, action) => {
      state.notifications.unshift(action.payload)
      state.unreadCount += 1
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnreadCount.fulfilled, (state, action) => {
        state.unreadCount = action.payload
      })
      .addCase(fetchNotifications.pending, (state) => { state.loading = true })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.loading = false
        state.notifications = action.payload
      })
      .addCase(fetchNotifications.rejected, (state) => { state.loading = false })
  },
})

export const { incrementUnread, clearUnread, addNotification } = notificationSlice.actions
export default notificationSlice.reducer
